import { Link } from "react-router-dom";
import type { Work } from "@/types";
import Badge from "@/components/base/Badge";
import { useFavorites } from "@/context/FavoritesContext";

export default function TvCard({ work }: { work: Work }) {
  const { isFavorite, toggle } = useFavorites();
  const favored = isFavorite(work.id);

  return (
    <article className="group relative flex overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200">
      <Link to={`/detail/work/${work.id}`} className="relative block w-24 shrink-0 overflow-hidden bg-background-200 sm:w-28">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} - 电视剧 - 亚洲天堂`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <div className="mb-1.5 flex items-start justify-between gap-2">
          <h3 className="text-sm font-semibold text-foreground-900 md:text-base">
            <Link to={`/detail/work/${work.id}`} className="cursor-pointer transition-colors hover:text-primary-700">
              {work.title}
            </Link>
          </h3>
          <button
            type="button"
            onClick={() => toggle(work.id)}
            aria-label={favored ? "取消收藏" : "收藏"}
            className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm transition-colors ${
              favored ? "bg-accent-500 text-background-50" : "bg-background-100 text-foreground-500 hover:text-accent-600"
            }`}
          >
            <i className={favored ? "ri-bookmark-fill" : "ri-bookmark-line"} aria-hidden="true"></i>
          </button>
        </div>
        <div className="mb-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
            {work.rating.toFixed(1)}
          </span>
          <span className="text-foreground-300">·</span>
          <span>{work.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{work.region}</span>
        </div>
        <p className="mb-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">{work.synopsis}</p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5">
          <Badge tone="primary" className="text-[10px]">{work.seasons ?? 1} 季</Badge>
          <Badge tone="secondary" className="text-[10px]">
            {work.airStatus === "连载" ? `更新至第 ${work.latestEpisode} 集` : `全 ${work.latestEpisode} 集`}
          </Badge>
          {work.airStatus ? (
            <Badge tone={work.airStatus === "连载" ? "accent" : "outline"} className="text-[10px]">
              {work.airStatus}
            </Badge>
          ) : null}
        </div>
      </div>
    </article>
  );
}